import styled from '@emotion/styled';

const EmptyWrapper = styled('div')({
  marginTop: '6rem',
  textAlign: 'center',
});

export default EmptyWrapper;
